module.exports = __webpack_public_path__ + "img/content-1.d0951fa2.png";